import React from 'react';

import './index.scss';

const CrossIcon = () => {
    return (
        <div className="cross-circle">
            <div className="cross" >
            </div>
        </div>
    );
};

export default CrossIcon;